// Unlike the RPC_* endpoint maps, these are REST paths with an id segment,
// so session-scoped ones are builder functions rather than plain strings.
export const AIAGENT_ENDPOINTS = {
    SEND_MESSAGE: "/korres",
    SEND_MESSAGE_STREAM: "/korres/stream",
    STARTER_QUESTIONS: "/starter-questions",
    SESSIONS: "/sessions",
    SESSION: (sessionId) => `/sessions/${sessionId}`,
    SESSION_CHATS: (sessionId) => `/sessions/${sessionId}/chats`,
    SESSION_PIN: (sessionId) => `/sessions/${sessionId}/pin`,
    FEEDBACK: "/feedback",
    FEEDBACK_ISSUE_TYPES: "/feedback/issue-types",
    FEEDBACK_SURVEY: "/feedback/survey",
};
